import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';
import EmptyState from '../components/common/EmptyState';

const ComingSoon = ({ title, description }) => (
    <EmptyState
        icon={SparklesIcon}
        title={title || 'Coming soon'}
        description={
            description ||
            'This area is part of the internship portal and will be available in a later step. Your existing data is unchanged.'
        }
        action={
            <Link to="/dashboard" className="btn-primary">
                Back to Home
            </Link>
        }
    />
);

export default ComingSoon;
